import axios from 'axios';

const PRODUCTION_API = 'https://artinventoryserver.herokuapp.com/';
const DEVELOPMENT_API = 'http://localhost:3500/';

const BASE_URL = process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'production' ? PRODUCTION_API : DEVELOPMENT_API);

/** Base URL for image upload/get endpoints (e.g. /single). */
export const UPLOAD_BASE = process.env.REACT_APP_UPLOAD_URL || BASE_URL;


/* https://artinventoryserver.herokuapp.com/ */
/* http://localhost:3500/ */

export default axios.create({
    baseURL: BASE_URL,
    withCredentials: true
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});
